import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Link, LinkProps } from '@bbkShared/react-router';
import { useUrl } from '@bbkAdminUtils/nav';
import Icon from '@bbkAdminComponents/icons/icon-generator';
import './styles/buttons.scss';

type Props = {
  title: React.ReactNode;
  href?: string;
  toOptions?: LinkProps['to'];
  arrow?: boolean;
} & Omit<LinkProps, 'to' | 'title'>;

export const LinkButton: React.FC<Props> = ({
  title,
  href,
  toOptions,
  arrow = true,
  ...restLinkProps
}) => {
  const createUrl = useUrl();
  const to = toOptions ?? createUrl(href);
  return (
    <Link
      to={to}
      className={cs('bbk-button', 'primary', 'arrowButton', 'brightPurple')}
      {...restLinkProps}
    >
      <span className="text">{title}</span>
      {arrow && <Icon name="arrow" />}
    </Link>
  );
};
